import React from 'react';
import styles from './AboutMe.module.css';

const AboutMe: React.FC = () => {
  return (
    <div className={styles.aboutMe}>
      <h2>About Me</h2>
      <div className={styles.content}>
        <div className={styles.summary}>
          <p>
            I am software engineer with 7+ years in software development,
            ranging from full-stack development, mainly on the backend, to devops roles.
          </p>
          <p>
            Currently I focus on backend and devops roles, working with technologies such as Docker/Kubernetes,
            and building resilient microservices. I create APIs, implement CI/CD pipelines, manage infrastructure
            and ensure robust monitoring and logging systems.
          </p>
          <p>
            Having worked across the stack, I bring a unique perspective to backend
            development and understanding how architectural decisions impact the entire
            application lifecycle. I am committed to maintaining high-performance,
            scalable systems while advocating for well designed systems.
          </p>
          <p>
            I'm a passionate software engineer specializing in full-stack development
            with expertise in React, TypeScript, and Node.js. With a strong foundation
            in software architecture and clean code practices, I strive to create
            efficient and scalable solutions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;